import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'

class PromptDialog extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      value: this.props.value
    }
  }

  render () {
    const props = this.props
    return (
      <React.Fragment>
        <BasicHeader title='Common.Prompt' {...props} />
        <ModalBody>
          <Input
            autoFocus
            defaultValue={this.state.value}
            onChange={
              (event) => { this.setState({ value: event.target.value }) }
            } />
        </ModalBody>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => this.props.onAction(this.state.value)} />
      </React.Fragment>
    )
  }
}

export default {
  component: PromptDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/prompt.js